<template>
    <div class="vehicle-drilldown">
        <div class="row">
            <div class="col-12 col-md-4">
                <label for>{{ label_manufacturer }} </label>
                <select name id v-model="manufacturerId" :disabled="manufacturers.length == 0">
                    <option value="0" disabled>Select</option>
                    <option
                    v-for="(manufacturer, manufacturerIndex) in manufacturers"
                        :key="manufacturer.manufacturerId + manufacturerIndex"
                    :value="manufacturer.manufacturerId"
                    >{{ manufacturer.title }}</option>
                </select>
            </div>
            <div class="col-12 col-md-4">
                <label for>{{ label_canopy }} </label>
                <select name id v-model="canopyId" :disabled="canopies.length == 0">
                    <option value="0" disabled>{{ label_select }}</option>
                    <option
                    v-for="(canopy, canopyIndex) in canopies"
                        :key="canopy.canopyId + canopyIndex"
                    :value="canopy.canopyId"
                    >{{ canopy.title }}</option>
                </select>
            </div>
            <div class="col-12 col-md-4">
            </div>

            <div class="col-12">
                <div v-for="(vehicle, index) in vehicleTypes" :key="index">
                    <a href="javascript:;" v-on:click="vehicleTypeId = vehicle.vehicleTypeId">{{ vehicle.title }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "dealer-canopy",
    data: function() {
        return {
            manufacturers: [],
            manufacturerId: 0,
            canopies: [],
            canopyId: 0,
            vehicleTypes: [],
            vehicleTypeId: 0
        }
    },
    props: {
        label_manufacturer: {
            type: String,
            default: "Manufacturer"
        },
        label_canopy: {
            type: String,
            default: "Canopy"
        },
        label_select: {
            type: String,
            default: "Select"
        },
        label_vehicle_type: {
            type: String,
            default: "Vehicle Type"
        },
    },
    mounted() {
        this.getManufacturers();
    },
    methods: {
        async getManufacturers() {
            let response = await axios.get(`api/canopy/manufacturers`);
            this.manufacturers = response.data.data.sort(function(a,b){
                if (a.title > b.title) {
                    return 1;
                } else if (a.title == b.title) {
                    return 0;
                } else {
                    return -1;
                }
            });
        },
        canopyName() {
            var title = '';
            for (var i = 0; i < this.manufacturers.length; i++) {
                if (this.manufacturers[i].manufacturerId == this.manufacturerId) {
                    title = this.manufacturers[i].title;
                }
            }
            for (var i = 0; i < this.canopies.length; i++) {
                if (this.canopies[i].canopyId == this.canopyId) {
                    title = title + ' - ' + this.canopies[i].title;
                }
            }
            for (var i = 0; i < this.vehicleTypes.length; i++) {
                if (this.vehicleTypes[i].vehicleTypeId == this.vehicleTypeId) {
                    title = title + ' - ' + this.vehicleTypes[i].title;
                }
            }
            return title;
        },
    },
    watch: {
      async manufacturerId() {
        this.canopies = [];
        this.vehicleTypes = [];
        if (this.manufacturerId) {
            let response = await axios.get(`api/canopy/manufacturers/${this.manufacturerId}`);
            this.canopies = response.data.data;
        }
      },
      async canopyId() {
        this.vehicleTypes = [];
        if (this.canopyId) {
            let response = await axios.get(`api/solutions/item/1/canopy/${this.canopyId}`);
            this.vehicleTypes = response.data.data.vehicleTypes;
        }
      },
      async vehicleTypeId() {
        if (this.vehicleTypeId) {
            this.$emit('selectCanopy', {canopyId: this.canopyId + '/' + this.vehicleTypeId, full_name: this.canopyName()});
        }
      }
    }
};
</script>
